import { PaymentMethod, PaymentOption } from "@modules/checkout/types/checkout"

export interface AvailablePayment {
  BANK_TRANSFER?: PaymentOption[]
  EWALLET?: PaymentOption[]
  CREDIT_CARD?: PaymentOption[]
  PAY_LATER?: PaymentOption[]
}
export interface CheckoutState {
  //Initial state
  gross_price: number
  available_payment: AvailablePayment

  //personal info
  fullname: string
  email?: string
  user_phone_number: string
  user_gender: number
  user_birthday: string

  //Survey state
  info_from: string[]
  other_option: string
  is_other_option_selected: boolean

  //error state
  error_discount: string
  error_submitting: string
  error_admin_fee: string
  error_survey: string
  error_personal_info: string
  error_phone_number: string

  //state for payment
  admin_fee: number
  selected_method: string
  total_price: number

  //Promo
  promo_id: string
  promo_code: string
  discount_amount: number
  promo_name: string
  applied_promo_code: string
}

export interface Discount {
  id: string
  discount_name: string
  discount_code: string
  discount_deal: number
  order_discount: number
  order_referral_cut: number
  discount_description: string
  available_payment: AvailablePayment
}

export interface PaymentInitializerPayload {
  price: number
  email?: string
  available_payment: AvailablePayment
  fullname?: string
  user_phone_number?: string
  user_gender?: number
  user_birthday?: Date | string
}

export interface PaymentOptionPayload {
  payment_fee: number
  payment_method: PaymentMethod
}

export interface OtherOptionPayload {
  other_option?: string
  is_other_option_selected?: boolean
}

export enum CheckoutActionType {
  PaymentInitializer = "payment_initializer",
  ChoosePayment = "choose_payment",
  InputSurvey = "input_survey",
  InputOtherOption = "input_other_option",
  InputPromoCode = "input_promo_code",
  ApplyPromo = "apply_promo",
  ErrorSurvey = "error_survey",
  ErrorDiscount = "error_discount",
  ErrorPhoneNumber = "error_phone_number",
  DeleteDiscount = "delete_discount",
  ErrorSubmitting = "error_submitting",
  ErrorPersonalInfo = "error_personal_info",
  PersonalInfo = "pesonal_info",
}

export type CheckoutAction =
  | {
      type: CheckoutActionType.PaymentInitializer
      payload: PaymentInitializerPayload
    }
  | { type: CheckoutActionType.ChoosePayment; payload: PaymentOptionPayload }
  | {
      type:
        | CheckoutActionType.InputPromoCode
        | CheckoutActionType.InputSurvey
        | CheckoutActionType.ErrorDiscount
        | CheckoutActionType.ErrorSubmitting
        | CheckoutActionType.ErrorSurvey
        | CheckoutActionType.ErrorPersonalInfo
        | CheckoutActionType.ErrorPhoneNumber
      payload: string
    }
  | {
      type: CheckoutActionType.DeleteDiscount
      payload?: any
    }
  | { type: CheckoutActionType.ApplyPromo; payload: Discount }
  | { type: CheckoutActionType.InputOtherOption; payload: OtherOptionPayload }
  | { type: CheckoutActionType.PersonalInfo; payload: any }
